/**
 * The reference range in the shape the save API accepts (`low`, `high`, `indexed`).
 * The catalog's `lowInclusive` / `highInclusive` only drive the on-screen abnormal flag,
 * which is computed here and sent as `isAbnormal`; sending them made the API reject the
 * whole save (Joi `unknown(false)`).
 */
export function toSavedNormalRange(
  range: { low?: number; high?: number; indexed?: boolean } | null | undefined
): { low?: number; high?: number; indexed?: boolean } | undefined {
  if (!range) return undefined;
  const out: { low?: number; high?: number; indexed?: boolean } = {};
  if (range.low != null) out.low = range.low;
  if (range.high != null) out.high = range.high;
  if (range.indexed != null) out.indexed = range.indexed;
  return out;
}
